export const breadcrumbData = [
  {
    text: "You can set breadcrumb using ",
    code: ".breadcrumb ",
  },
  {
    text: " class.",
  },
];

export const dividerBreadcrumbData = [
  {
    text: "You can set breadcrumb using ",
    code: ".breadcrumb-icon",
  },
  {
    text: " class.",
  },
];

export const withIconBreadcrumbData = [
  {
    text: "You can set breadcrumb using ",
    code: ".breadcrumb ",
  },
  {
    text: " class.",
  },
];

export const variationOfBreadcrumbData = [
  {
    text: "You can set breadcrumb using ",
    code: ".breadcrumb ",
  },
  {
    text: "class through any icons sets.",
  },
];

export const coloredBreadcrumbData = [
  {
    text: "You can set breadcrumb using ",
    code: ".breadcrumb ",
  },
  {
    text: " class and set background colors like ",
    code: "[.bg-*].",
  },
];

export const coloredBreadcrumbDataList = [
  {
    className: "mb-4 bg-secondary",
    span: [
      {
        title: "Home",
      },
      {
        title: "Icons",
      },
      {
        activeTitle: "Flag-icon",
      },
    ],
  },
  {
    className: "mb-4 bg-tertiary",
    span: [
      {
        title: "Home",
      },
      {
        title: "Gallery",
      },
      {
        activeTitle: "Gallery-grid",
      },
    ],
  },
];

export const outlineBreadcrumbData = [
  {
    text:"You can set breadcrumb using",
    code:".breadcrumb, .bg-outline-primary"
  },
  {
    text:"class and set background colors like"
  },
]